module.exports = __webpack_public_path__ + "static/media/default_user.c3631c65.png";